// Configuration for the Pro tier (Stripe Checkout + feature gating).
//
// The Pro API base URL is provided at build time via REACT_APP_PRO_API_URL
// (the API Gateway invoke URL output by the StripeApiStack, e.g.
// https://abc123.execute-api.us-east-1.amazonaws.com/prod). When it is not set,
// the app runs in "free-only" mode: the Pro CTA still renders and explains that
// upgrades are coming soon, but no checkout call is attempted.

export const PRO_API_URL = (process.env.REACT_APP_PRO_API_URL || '').replace(/\/$/, '');

export const PRO_ENABLED = Boolean(PRO_API_URL);

// Pricing copy shown in the upgrade modal. Amounts must match the Stripe prices.
export const PRICING = {
  subscription: { label: 'Pro Monthly', amount: '$2.99', cadence: '/month' },
  oneTime: { label: 'HD Export', amount: '$0.99', cadence: 'one-time' },
};

export const PRO_FEATURES = [
  'Remove all ads',
  'HD export (2× resolution, no watermark)',
  'Unlock every silhouette',
  'Upload your own custom silhouettes',
];

// localStorage key holding the Stripe Checkout session id of a completed purchase.
export const ENTITLEMENT_STORAGE_KEY = 'nutscaper_pro_session';

// Default (free) feature set.
export const FREE_FEATURES = {
  removeAds: false,
  hdExport: false,
  allSilhouettes: false,
  customUpload: false,
};
